require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-on-the-rise-the-latest-technology-is-taking-centre.json") })
        }
      }, "path---news-on-the-rise-the-latest-technology-is-taking-centre");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-on-the-rise-the-latest-technology-is-taking-centre!./.cache/json/news-on-the-rise-the-latest-technology-is-taking-centre.json
// module id = 833
// module chunks = 231608221292675